"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[58032],{

/***/ 58032:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _LoaderRemote__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(71593);
/* harmony import */ var _ProductDestinations_ProductDestinationsContainer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8710);






var ProductDestinations = function(param) {
    var data = param.data;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ProductDestinations_ProductDestinationsContainer__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        children: data && data.map(function(e, index) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "flex-33 p-2",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                    href: e.url,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        title: e.title,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "text-center relative h-20 rounded-md overflow-hidden ",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                                    src: e.resim,
                                    layout: "fill",
                                    loader: _LoaderRemote__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z,
                                    objectFit: "cover",
                                    objectPosition: "center",
                                    alt: e.title,
                                    sizes: "(max-width: 768px) 25vw,",
                                    placeholder: "blur",
                                    blurDataURL: (0,_LoaderRemote__WEBPACK_IMPORTED_MODULE_5__/* .Blur */ .x)(e.resim),
                                    priority: index == 0
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "text-white absolute bottom-2 text-lg font-semibold left-1/2 -translate-x-1/2 z-10",
                                    children: e.baslik
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "absolute inset-0 bg-gradient-to-t from-[#323232] to-transparent"
                                })
                            ]
                        })
                    })
                })
            }, index);
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (ProductDestinations);


/***/ })

}]);